/* Import necessary libraries from nodes_modules and initialise */
import $ from 'jquery';
window.$ = $;
window.jQuery = $;

/* Import Javascript Libraries */
import './libs/common.js';

/* Import common JS objects */
import { SearchDropdown } from './libs/searchDropdown.js';

/* Import the page specific JS */
import { SearchPage } from './pages/search.js';

/* Import Stripe Express Pay */
import StripeExpressPay from './libs/stripe/express.js';

/* Import Banner Slider */
import BannerSlider from './components/bannerSlider.js';

/* Initialise common JS objects and attach to window for global access */
window.searchDropdown = new SearchDropdown('searchInput');

/* Initialise and attached page specific JS to the window for global access */
window.searchPage = new SearchPage('product-filter');

/* Initialise Stripe Express Pay */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.stripe-express-pay-button-container').forEach(function (container) {
    StripeExpressPay.initFromContainer(container);
  });
});

/* Initialise Banner Slider */
window.bannerSlider = new BannerSlider('.bnnrSlider');

/* Global Cosmetify JS */
var logged_in = false;

function custIdentify(customer) {
    try {
        klaviyo.push(['identify', { '$email': customer }]);
    } catch (err) { }
}

function processFavResult(result) {
    logged_in = result['logged_in'];
    let customer = result['customer'];

    if (customer) {
        custIdentify(customer);
    }

    if (logged_in == true) {
        $('.myAct use').attr('xlink:href', '#userSolid');
        $('.myAct').addClass('pink');

        if ($('#alertFrm input[name="type_name"]').val() == 'stock') {
            $('.noStk form input').hide();
        }
    }

    $('.like').each(function () {
        var current = $(this)[0].dataset.pvid;
        if ($.inArray(current, result['faves']) != -1) {
            $(this).addClass('liked');
            $(this).find('use').attr('xlink:href', '#heartSolid');
        }
    });
}

function getFavs(favData) {
    $('.myAct use').attr('xlink:href', '#user');
    $('.myAct').removeClass('pink');

    if (!favData) {
        $.ajax({
            url: url_prefix + "/faves/show/1/", dataType: 'json', success: function (result) {
                processFavResult(result);
            }
        });
    } else {
        processFavResult(favData);
    }
}

function basketCount(count) {
    $('.myBasket>span').remove();
    $('.myBasket').find('use').attr('xlink:href', '#cart');
    $('.myBasket').removeClass('pink');

    if (count > 0) {
        $('.myBasket').find('use').attr('xlink:href', '#cartSolid');
        $('.myBasket').addClass('pink');
        $('.myBasket').append("<span>" + count + "</span>");
    }
}

function processBasketData(cartData) {
    try {
        basketCount(cartData['prods'].length);

        if (cartData['customer']) {
            custIdentify(cartData['customer']);
        }
    } catch (err) { console.log(err) }
}

function klaviyoAddToCart(item, qty, cartData) {
    try {
        if (cartData['customer']) {
            custIdentify(cartData['customer']);
        }

        let items = [];
        let itemNames = [];

        for (let i = 0; i < cartData['basket_data'].length; i++) {
            let data = {
                "ProductID": cartData['basket_data'][i]['sku'],
                "SKU": cartData['basket_data'][i]['sku'],
                "Brand": cartData['basket_data'][i]['other']['brandName'],
                "ProductName": cartData['basket_data'][i]['name'],
                "BrandlessName": cartData['basket_data'][i]['other']['brandlessName'],
                "PV": cartData['basket_data'][i]['other']['pvName'],
                "Quantity": cartData['basket_data'][i]['quantity'],
                "Price": cartData['basket_data'][i]['salePrice'],
                "RRP": cartData['basket_data'][i]['unitPrice'],
                "RowTotal": cartData['basket_data'][i]['totalPrice'],
                "RowRRP": cartData['basket_data'][i]['other']['unitTotalPrice'],
                "ProductURL": cartData['basket_data'][i]['productUrl'],
                "ProductAppURL": cartData['basket_data'][i]['other']['appDeepLink'],
                "IOSProductAppURL": cartData['basket_data'][i]['other']['appIOSDeepLink'],
                "AndroidProductAppURL": cartData['basket_data'][i]['other']['appAndroidDeepLink'],
                "ImageURL": cartData['basket_data'][i]['imageUrl']
            }
            items.push(data); itemNames.push(cartData['basket_data'][i]['name']);
        }

        if (cartData['order_id']) {
            klaviyo.push(["track", "Added to Cart", {
                "$value": cartData['total_order_gross'],
                "AddedItemBrand": item['brand_name'],
                "AddedItemProductName": item['full_name'],
                "AddedItemBrandlessName": item['brandless_name'],
                "AddedItemPV": item['pv_name'],
                "AddedItemProductID": item['sku'],
                "AddedItemSKU": item['sku'],
                "AddedItemImageURL": item['image'],
                "AddedItemURL": item['url'],
                "AddedItemPrice": item['price'],
                "AddedItemRRP": item['rrp'],
                "AddedItemQuantity": qty,
                "ItemNames": itemNames,
                "CheckoutURL": cartData['basket_url'],
                "Items": items
            }]);
        }
    } catch (err) { console.log(err) }
}

function gaEcommerceEvent(pvid, type, qty, currentCart) {
    $.get({
        url: url_prefix + "/get-ecommerce-data/" + pvid + "/", dataType: 'json', success: function (cartData) {

            if (currentCart) {
                klaviyoAddToCart(cartData, qty, currentCart);
            }

            dataLayer.push({ ecommerce: null });

            let itemData = {
                item_id: cartData['sku'],
                item_name: cartData['product_name'],
                item_brand: cartData['brand_name'],
                quantity: qty
            }

            if (cartData['discount']) {
                itemData['discount'] = parseFloat(cartData['discount']);
            }

            if (cartData['rrp']) {
                itemData['price'] = parseFloat(cartData['rrp']);
            } else {
                itemData['price'] = parseFloat(cartData['price']);
            }

            if (cartData['pv_name']) {
                itemData['item_variant'] = cartData['pv_name'];
            }

            if (type === 'add_to_cart') {
                dataLayer.push({
                    'addCurrency': cartData['currency'],
                    'addProductPrice': parseFloat(cartData['price']),
                    'addSku': cartData['sku'],
                    'addQty': qty,
                    'addValue': parseFloat(cartData['price']) * qty
                });
            }

            dataLayer.push({
                event: type,
                ecommerce: {
                    currency: cartData['currency'],
                    value: parseFloat(cartData['price']),
                    items: [itemData]
                }
            });
        }
    });
}

function getBasket(cartData) {
    if (!window.location.href.includes("/basket/")) {
        if (!cartData) {
            $.ajax({
                url: `${url_prefix}/basket/api/get/1/1/`, dataType: 'json', success: function (result) {
                    processBasketData(result)
                }
            });
        } else {
            processBasketData(cartData)
        }
    }
}

function applyVf() {
    $('.items>div').each(function () {
        let pv = $(this).find('.like')[0].dataset.pvid;
        let link = $(this).find('a').attr("href");
        if (!link.includes("vf=") && !link.includes("pv=") && !link.includes("aid=")) {
            $(this).find('a').attr("href", link + "?vf=" + pv);
        }
    });
    $('.blogPost button.addBasket').each(function () {
        let pv = $(this)[0].dataset.pvid;
        let haspvs = $(this)[0].dataset.haspvs;
        let link = $(this).parent().parent().find('div>a:first, h2>a, h3>a, h4>a').attr("href");
        if (!link.includes("vf=") && !link.includes("pv=") && haspvs === "False") {
            $(this).parent().parent().find('div>a:first, h2>a, h3>a, h4>a').attr("href", link + "?vf=" + pv);
        }
    });
}

function productAddedRedirect() {
    let rurl = window.location.href.replace("#writtenReviews", "");
    if (rurl.includes("vf=") || rurl.includes("aid=") || rurl.includes("pv=")) {
        window.location.href = rurl;
    } else {
        window.location.href = rurl.split('?')[0] + '?vf=' + pv_id;
    }
}

function submitAlert() {
    let type = $('#alertFrm input[name="type_name"]').val();
    let id = $('#alertFrm input[name="type_id"]').val();
    let newsletter = 0;
    let email = '';

    if (logged_in == true) {
        email = 'loggedin@cosmetify.com';
    } else {
        email = $('#alertFrm input[name="email"]').val();
        if ($('#alertFrm input[name="newsletter"]').is(':checked')) {
            newsletter = 1;
        }
        custIdentify(email);
    }

    if (!email?.trim()) {
        return;
    }

    $.get({
        url: url_prefix + "/alert-sign-up/" + email + "/" + type + "/" + id + "/" + newsletter + "/",
        success: function () {
            if ($('#alertFrm input[name="type_name"]').val() == 'stock') {
                $('.noStk').append('<span class="suc">Your alert has been set up.</span>');
            } else {
                $('.alert .loading').addClass('done');
                $('.alert>div>div+div').append('<span class="suc">Your alert has been set up.</span>');
            }
        },
        error: function () {
            if ($('#alertFrm input[name="type_name"]').val() == 'stock') {
                $('.noStk').append('<span class="suc">There was an issue, please try again.</span>');
            } else {
                $('.alert .loading').addClass('done');
                $('.alert>div>div+div').append('<span class="suc">There was an issue, please try again.</span>');
            }
        }
    });
}

function alertSignup() {
    showOvly();
    openPopup('.alert');

    if (logged_in == true) {
        $('.alert form, .alert p, .alert>div>div+div span').hide();
        submitAlert();
    } else {
        $('.alert .loading').addClass('done');
    }
}

function alertForm(e) {
    e.preventDefault();
    $('.alert span.msg, .noStk span.msg').remove();

    if ($('#alertFrm input[name="type_name"]').val() == 'stock') {
        if (logged_in == true) {
            $('#alertFrm button').attr("disabled", true);
            $('.noStk form').hide();
            submitAlert();
        } else {
            if (emailValidation($('#alertFrm input[name="email"]').val())) {
                $('#alertFrm button').attr("disabled", true);
                $('.noStk form').hide();
                submitAlert();
            } else {
                $('.noStk form').prepend('<span class="msg">Please enter a valid email address</span>');
            }
        }
    } else {
        if (emailValidation($('#alertFrm input[name="email"]').val())) {
            $('#alertFrm button').attr("disabled", true);
            $('.alert .loading').removeClass('done');
            $('.alert form, .alert p, .alert>div>div+div span, .noStk form').hide();
            submitAlert();
        } else {
            $('.alert .fIpt').before('<span class="msg">Please enter a valid email address</span>');
        }
    }
}

function refineFilters() {
    $('.filters h3').after('<button class="rmvFil">Remove all filters <svg><use xlink:href="#close"/></svg></button></div>');
    $('.showing').prepend('<button class="rmvFil">Remove all filters <svg><use xlink:href="#close"/></svg></button></div>');
}

function applyFilters() {
    $('.filters input').attr("disabled", true);

    var url = window.location.href.split('?');
    url = url[0].split('#');
    url = url[0];
    let brands = [];
    let brandFilters = '';
    let filters = [];
    let filtersFilters = '';
    let categories = [];
    let categoriesFilters = '';
    let urlParam = '?';
    let frmMob = false;
    let sortByUrl = '';
    let offerUrl = '';
    let brandUrl = '';
    let categoryUrl = '';
    let filterUrl = '';
    if (window.innerWidth < 1150) { frmMob = true; }

    $('.filters input[type=checkbox]').each(function () {
        if ($(this).is(':checked')) {
            if ($(this).parents().eq(3).attr('class') === 'brands') {
                brands.push($(this).attr('id').substring(1));
            } else if ($(this).parents().eq(3).attr('class') === 'category') {
                categories.push($(this).attr('id').substring(1));
            } else if ($(this).parents().eq(3).attr('class') === 'offers') {
                //Ignore
            } else {
                filters.push($(this).attr('id').substring(1));
            }
        }
    });

    if (brands.length > 0) {
        brandUrl = '?brands=';
        let i;
        for (i = 0; i < brands.length; ++i) {
            if (i === 0) {
                brandFilters = brands[i];
            } else {
                brandFilters = brandFilters + ',' + brands[i];
            }
        }
        brandUrl = brandUrl + brandFilters;
        urlParam = '&';
    } else {
        brandUrl = '';
    }

    if (filters.length > 0) {
        filterUrl = urlParam + 'filters=';
        let i;
        for (i = 0; i < filters.length; ++i) {
            if (i === 0) {
                filtersFilters = filters[i];
            } else {
                filtersFilters = filtersFilters + ',' + filters[i];
            }
        }
        filterUrl = filterUrl + filtersFilters;
        urlParam = '&';
    } else {
        filterUrl = '';
    }

    if (categories.length > 0) {
        categoryUrl = urlParam + 'categories=';
        let i;
        for (i = 0; i < categories.length; ++i) {
            if (i === 0) {
                categoriesFilters = categories[i];
            } else {
                categoriesFilters = categoriesFilters + ',' + categories[i];
            }
        }
        categoryUrl = categoryUrl + categoriesFilters;
        urlParam = '&';
    } else {
        categoryUrl = '';
    }

    if ($('#sortBy option:selected').val() != 0) {
        sortByUrl = urlParam + 'sort=' + $('#sortBy option:selected').val();
        urlParam = '&';
    }

    if ($('#offers').is(':checked') || $('#offersMob').is(':checked')) {
        offerUrl = urlParam + 'products=sale-only';
    }

    if (frmMob) {
        var goto = url + brandUrl + filterUrl + categoryUrl + sortByUrl + offerUrl;
        var nothing = url;
        if (window.location != goto) {
            window.location.href = goto;
        }
    } else {
        window.location.href = url + brandUrl + filterUrl + categoryUrl + sortByUrl + offerUrl;
    }
}

function logProductImpression(pv_id, in_stock, dest) {
    if (url_prefix === '/us') {
        return;
    }

    var template = $('main').attr('class').split(' ')[0];
    var source = getCookie('csclick');
    var slug = window.location.pathname;

    $.ajax({
        url: url_prefix + "/log-product-impression/",
        type: 'POST',
        data: {
            pv_id: pv_id,
            in_stock: in_stock,
            template: template,
            dest: dest,
            source: source,
            slug: slug
        }
    });
}

function loadVariant(val) {
    if ($('#quickBuyPopup').is(':visible')) {
        $('#quickBuyPopup .inject').addClass('updating');
        $('#quickBuyPopup>.loading').show();
        $.ajax({
            url: url_prefix + "/get-product/" + val + "/popup/?vf=" + val + "",
            dataType: 'json',
            success: function (result) {
                $('#quickBuyPopup .inject .quickBuy').remove();
                $('#quickBuyPopup .inject').html(result['html']);

                $('#quickBuyPopup .inject .quickBuy .priceCon').append($('#quickBuyPopup .inject .quickBuy .pdtBuy .qty'));
                $('#quickBuyPopup .inject .quickBuy .priceCon .price>span').add($('#quickBuyPopup .inject .quickBuy .priceCon .price>span').next()).wrapAll('<div></div>');

                $('#quickBuyPopup .inject').removeClass('updating');
                $('#quickBuyPopup>.loading').hide();

                logProductImpression(val, result['in_stock'], 'quick buy');
            }
        });
    } else {
        let url = window.location.href.replace("#writtenReviews", "");;
        let org_url = window.location.href;
        if (url.indexOf("?") > 0) {
            url = url.substring(0, url.indexOf("?"));
        }

        if (org_url.includes("?aid=")) {
            let aid = getUrlParam('aid');
            url += "?aid=" + aid + "&pv=" + val;
        } else {
            url += "?pv=" + val;
        }

        window.location.replace(url);
    }
}

function resetLoginPopup() {
    $('#withEmailSignup, #withSwitch').show();
    $('.login .hd span').text("Sign in or register");
    $('.login #withEmail p').removeClass('suc').html('Enter your email address and we’ll send you a unique sign in link:');
    $('#withEmailSignup button').attr("disabled", false).removeClass('bLoad').find('svg').remove();
    $('#withEmailSignup input').val('');
    $('#withSocial').show();
    $('#withEmail').hide();
}

$(document).ready(function () {
    $('body').on('click', '.fCls', function (e) {
        e.preventDefault();
        if ($(this).hasClass('addedClose')) {
            productAddedRedirect();
        } else {
            closePopup();
        }
        resetLoginPopup();
    });

    $('body').on('click', '.ovly', function () {
        if (window.innerWidth < 1150) {
            return;
        }
        if (!$('body').hasClass("spa")) {
            if ($('main').hasClass("pdt") && $('.added').is(':visible') && !$('#quickBuyPopup.added').is(':visible')) {
                productAddedRedirect();
            } else {
                closePopup();
            }
        }
        resetLoginPopup();
    });

    $('body').on('click', '#alertBtn', function () {
        alertSignup();
    });

    $('body').on('submit', '#alertFrm', function (e) {
        alertForm(e);
    });

    $('.cCheck').each(function (index) {
        var wrapWidth = $(this).width() - 30;
        var eWidth = 0;

        $(this).children().each(function (index) {
            eWidth += parseInt($(this).width());
        });

        if (eWidth > wrapWidth && window.innerWidth < 1150) {
            $(this).parent().removeClass('center');
        } else {
            $(this).parent().addClass('center');
        }
    });

    var $body = $('body');
    var $searchInput = $('#searchInput');
    var $ovly = $('#ovly');
    var $searchCon = $('.searchCon');
    $searchInput.on('focus', function() {
        $body.addClass('spa');
    });
    $searchInput.on('blur', function() {
        setTimeout(function() {
            if (window.innerWidth < 1150) {
                return;
            }
            if (!$searchCon.find(':focus').length) {
                $body.removeClass('spa');
            }
        }, 150);
    });
    $ovly.on('click', function() {
        if (window.innerWidth >= 1150) {
            $body.removeClass('spa');
            $searchInput.blur();
        }
    });

    /*Filters*/
    $('body').on('click', '#mFilter', function () {
        $('body').addClass('stopScroll');
        $('.filters').addClass('a');
    });

    $('body').on('click', '.filters p, .filters h4', function () {
        if (window.innerWidth < 1150) {
            $(this).next('div').addClass('sa');
            $('.filters .hd span').text($(this).find('span').text());
        } else {
            if (!$(this).hasClass('up')) {
                $('.filters p, .filters h4').removeClass('up');
                $('.filters p+div, .filters h4+div').hide();
            }
            $(this).toggleClass('up');
            $(this).next('div').toggle();
        }
    });

    $('body').on('click', '.filters input[type=checkbox]', function () {
        if ($('#offersMob').is(':checked')) {
            $('#offers').attr('checked');
        } else {
            $('#offers').removeAttr('checked');
        }
        applyFilters();
    });

    $('body').on('click', '.filters input:radio[name=sortByRadio]', function () {
        let selected = $(this).val();
        $("#sortBy").val(selected);
        applyFilters();
    });

    $('#sortBy').on('change', function () {
        applyFilters();
    });

    $('body').on('click', '.rmvFil', function () {
        $('.filters input:checked, #offers, #offersMob').removeAttr('checked');
        applyFilters();
    });

    $('#offers').change(function () {
        $('#offers').attr("disabled", true);

        if ($('#offers').is(':checked')) {
            $('#offersMob').attr('checked');
        } else {
            $('#offersMob').removeAttr('checked');
        }

        $('.filters button').attr("disabled", true);
        $('.filters input').attr("disabled", true);
        setTimeout(applyFilters, 400);
    });

    var fUrl = window.location.href.split('?');
    if (fUrl.length > 1) {
        if (fUrl[1].indexOf('page_no') && fUrl[1].indexOf('&')) {
            if ($('.filters input[type=checkbox]:checked').length >= 1) { refineFilters(); }
            let hasFilters = true;
            $('.filters input:checked').each(function () {
                let txt = $(this).next().text().trim();
                let heading = $(this).parents().eq(3).children('p, h4');
                if (heading.children('i').length > 0) {
                    let old = heading.children('i').text();
                    txt = old + ", " + txt;
                    heading.children('i').remove();
                }
                heading.append('<i>' + txt + '</i>');
            });
        }
        var sorted = urlParam('sort');
        if (sorted) {
            $("#sortBy").val(sorted);
            $('.sortBy input:radio[name=sortByRadio]').filter("[value='" + sorted + "']").attr('checked', true);
            $("#sortBy option[value=0]").text("None");
        }
    }

    $('body').on('click', '.filCls', function () {
        if ($('.sa').last().length) {
            $('.sa').last().removeClass('sa');
            $('.filters .hd span').text('Refine By');
        } else {
            closePopup();
        }
    });

    /*Nav*/
    $(window).on('resize', function () {
        closePopup();
    });

    $('body').on('click', '.menu', function () {
        $('nav').addClass('a');
        $('body').addClass('stopScroll');
        $('#cm').insertAfter('nav>ul li:nth-child(4)');
        $('#mnav>a+div').removeClass('sa');
        $('nav .hd span').text('Shop Cosmetify');
        $('#mnav span.h1, #mnav .da').remove();

        if (window.innerWidth < 1150) {
            $('#mnav').show();
            $('nav.a').show();
        }
        else {
            $('#cm').hide();
            $('#mnav>a').removeClass('la');
            $('#mnav').show();

            $('#mnav>a').each(function () {
                if ($(this).next('div').length) {
                    $(this).addClass('la');
                    $(this).next('div').addClass('sa');
                    $(this).next('div').prepend('<span class="h1">' + $(this).text() + '</span>');
                    $(this).next('div').append('<a class="da" href="' + $(this).attr('href') + '">View all ' + $(this).text() + ' products</a>');
                    return false;
                }
            });
        }
    });
    $('body').on('click', 'nav a', function (e) {
        if (window.innerWidth < 1150) {
            if ($(this).next('div').length) {
                e.preventDefault();
                $(this).next('div').addClass('sa');
                $('nav .hd span').text($(this).text());

                if ($(this).next('div').children(":first").is('div') && !$(this).next('div').find('>div>div>a:first-child').hasClass('dma')) {
                    $(this).next('div').find('>div>div:first-child').prepend('<a class="dma" href="' + $(this).attr('href') + '">View All</a>');
                }
                if ($(this).next('div').children(":first").is('a') && !$(this).next('div').find('>a:first-child').hasClass('dma')) {
                    $(this).next('div').prepend('<a class="dma" href="' + $(this).attr('href') + '">View All</a>');
                }

            }
        } else {
            if ($(this).next('div').length && $(this).parent().hasClass('ls')) {
                e.preventDefault();
                $('#mnav a').removeClass('la');
                $('div').removeClass('sa');
                $('#mnav span.h1, #mnav .da').remove();
                $(this).addClass('la');
                $(this).next('div').addClass('sa');
                $(this).next('div').prepend('<span class="h1">' + $(this).text() + '</span>');
                $(this).next('div').append('<a class="da" href="' + $(this).attr('href') + '">View all ' + $(this).text() + ' products</a>');
            }
        }
    });

    $('body').on('click', '.navCls', function () {
        if ($('.sa').last().length) {
            if ($('.sa').length > 1) {
                $('.sa').last().removeClass('sa');
                $('nav .hd span').text($('.sa').prev().text());
            } else {
                $('.sa').last().removeClass('sa');
                $('nav .hd span').text('Shop Cosmetify');
            }
        } else {
            closePopup();
        }
    });
    /*Pagination*/
    $('body').on('click', '#btnShowMore', function (e) {
        e.preventDefault();
        $(this).addClass('bLoad');
        $(this).attr("disabled", true);
        $(this).append('<svg><use xlink:href="#loading" /></svg>');
        let page_no = parseInt(getUrlParam('page_no')) + 1;
        let next_page_no = parseInt(getUrlParam('page_no')) + 2;
        let url = window.location.href;
        let qs = url.split('?')[1];
        let remainder = '';
        let c_page = page_no - 1;
        let current_qs = 'page_no=' + page_no;
        let prev_qs = 'page_no=' + c_page;
        let next_qs = 'page_no=' + next_page_no;
        let updated_url = '';
        $(this).attr('href', $(this).attr('href').replace(current_qs, next_qs));
        if (url.indexOf('page_no') != -1) {
            updated_url = url.replace(prev_qs, current_qs);
        } else {
            let joiner = '?';
            if (url.indexOf('?') > 0) { joiner = '&' }
            updated_url = url + joiner + current_qs;
        }
        let updated_qs = updated_url.split('?')[1];

        let ajax_url;
        if (page_type == 'blog') {
            ajax_url = obj_url + '?' + updated_qs + '&ajax=1';
        } else {
            ajax_url = url_prefix + '/ajax-products/' + obj_id + '/' + page_type + '/' + '?' + updated_qs;
        }

        $.ajax({
            url: ajax_url, dataType: 'html', success: function (result) {
                $('#divAppend').append(result);
                history.pushState(null, null, updated_url);
                $('#btnShowMore').attr("disabled", false);
                $('#btnShowMore').removeClass('bLoad');
                let new_count = per_page * page_no;
                if (new_count >= total_prods) {
                    new_count = total_prods;
                    $('#btnShowMore').remove();
                }
                $('#btnShowMore').find('svg').remove();
                $('#prodProgressBar').attr('value', new_count);
                $('#c_prod_num').text(new_count);
            }
        });
    });

    /*Accordion*/
    $('.pm, .accordion dt, .signUp .msg, .retailers span').click(function () {
        $(this).toggleClass('up');
        $(this).next().slideToggle('slow');
    });

    $('#rma').click(function () {
        $(this).prev().slideToggle('slow', function () {
            $('#rma').slideUp();
        });
    });

    $('#orderContact').click(function () {
        $(this).parent().next().slideToggle('slow');
    });

    $('.chkout .contact form').on('submit', function (e) {
        $('.chkout .contact form .btn').attr("disabled", true);
        $('.chkout .contact form .btn').append('<svg><use xlink:href="#loading" /></svg>');
        $('.chkout .contact form .btn').addClass('bLoad');
    });

    /*Source Tracking*/
    var adUrl = "";
    var lastClick = getCookie("csclick");
    var firstClick = getCookie("csfirst");
    var campaginCookie = getCookie("cscampaign");

    if (lastClick === "") {
        var url = window.location.href;
        url = url.toLowerCase();
        var source = '';

        if (url.includes("blog")) {
            source = "csb";
        } else {
            source = "csw";
        }

        let d = new Date();
        d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();

        if (firstClick === "") {
            document.cookie = "csclick=" + source + ";" + expires + ";path=/";
            document.cookie = "csfirst=" + source + ";" + expires + ";path=/";
        } else {
            document.cookie = "csclick=" + firstClick + ";" + expires + ";path=/";
        }
    }

    if (campaginCookie != "") {
        adUrl = "&c_ad=" + campaginCookie;
    }

    /*Basket*/
    $('body').on('click', '.myBasket, .myBasketLnk', function () {
        window.location.href = url_prefix + '/basket/';
    });

    $('body').on('click', '.reInfo', function () {
        var popup = $(this).attr("id");
        openPopup('#' + popup.replace("pop-", "up-"));
        showOvly();
    });

    /*AddToBasket*/
    $('body').on('click', '.qtyCtl button', function (e) {
        let btns = $(this).parent().find('button');
        let qty = $(this).parent().find('#qtyCount');
        let minus = $(this).parent().find('#qtyMinus');
        let plus = $(this).parent().find('#qtyPlus');
        let max = parseInt(qty[0].dataset.max);
        let cur = parseInt(qty.text());
        let action = $(this).attr("id");

        btns.attr("disabled", true);

        if (action == 'qtyPlus') {
            cur += 1;
            qty.text(cur);
            if (cur == max) {
                minus.attr("disabled", false);
                plus.attr("disabled", true);
            } else {
                btns.attr("disabled", false);
            }
        } else {
            cur -= 1;
            qty.text(cur);
            if (cur == 1) {
                minus.attr("disabled", true);
                plus.attr("disabled", false);
            } else {
                btns.attr("disabled", false);
            }
        }
    });

    $('body').on('click', '.addBasket', function (e) {
        if ($(this)[0].dataset.basket === "False") { return }
        e.preventDefault();
        let pvid = $(this)[0].dataset.pvid;
        let qtyAdded = 1;

        let b_image = '', b_brand_name = '', b_product_name = '', b_pv_name = '', b_price = '', b_cur = '';

        if ($('main').hasClass('blogPost') && !$(this).hasClass('inLine')) {
            $('.addBasket').attr("disabled", true);
            $(this).children('span').hide();
            $(this).append('<svg><use xlink:href="#loading" /></svg>');
            $(this).addClass('bLoad');

            b_image = $(this)[0].dataset.img;
            b_brand_name = $(this)[0].dataset.bname;
            b_product_name = $(this)[0].dataset.pname;
            b_pv_name = $(this)[0].dataset.pvname;
            if (b_pv_name) {
                b_pv_name = `<div class="type">${b_pv_name}</div>`
            } else {
                b_pv_name = '';
            }
            b_price = $(this)[0].dataset.single;
            b_cur = $(this)[0].dataset.cur;

            $('#addFill, #companionsFill').empty();
            $('#addFill').append(`<div class="f nw ac"><div class="img"><img width="75" height="75" src="${b_image}" alt="${b_product_name}"></div><div class="info"><div class="brand">${b_brand_name}</div><div class="name">${b_product_name}</div>${b_pv_name}</div><div> <b>${b_cur}${b_price}</b></div></div>`);

            logProductImpression(pvid, true, 'page');
        }

        if ($(this).parent().parent().parent().parent().hasClass('quickBuy')) {
            $('.addBasket').attr("disabled", true);
            $('#quickBuyPopup .options, #quickBuyPopup .qty, #quickBuyPopup .btn.bb').css('pointer-events', 'none');
            $('#quickBuyPopup .addBasket>span').hide();
            $('#quickBuyPopup .addBasket').append('<svg><use xlink:href="#loading" /></svg>');
            $('#quickBuyPopup .addBasket').addClass('bLoad');

            if ($('#quickBuyPopup .qtyCtl').length) {
                let qtyNode = $('#quickBuyPopup #qtyCount');
                qtyAdded = parseInt(qtyNode.text());
            }

            b_image = $(this).parent().parent().parent().parent().find('.img picture source').attr('srcset') || $(this).parent().parent().parent().parent().find('.img img').attr('src');
            b_brand_name = $(this)[0].dataset.bname;
            b_product_name = $(this)[0].dataset.pname;
            b_pv_name = $(this)[0].dataset.pvname;
            if (b_pv_name) {
                b_pv_name = `<div class="type">${b_pv_name}</div>`
            } else {
                b_pv_name = '';
            }
            b_price = $(this)[0].dataset.single;
            b_cur = $(this)[0].dataset.cur;

            if (qtyAdded > 0) {
                b_price = (qtyAdded * parseFloat(b_price)).toFixed(2);
            }
        }

        if ($('main').hasClass('pdt') && $('.qtyCtl').length && !$('#quickBuyPopup').is(':visible')) {
            $('.addBasket').attr("disabled", true);
            $(this).children('span').css('visibility', 'hidden');
            $(this).append('<svg><use xlink:href="#loading" /></svg>');
            $(this).addClass('bLoad');

            var qtyNode = $('#qtyCount');
            var maxQty = qtyNode[0].dataset.max;
            qtyAdded = parseInt(qtyNode.text());
            var popupPrice = $('#popupAddBasketPrice');
            if ($(this).parent().parent().parent().parent().hasClass('retailers')) {
                var popupPrice = $(this);
            }
            if (qtyAdded > 0) {
                $('#popupAddBasketPrice').text((qtyAdded * parseFloat(popupPrice[0].dataset.single)).toFixed(2));
            } else {
                $('#popupAddBasketPrice').text(parseFloat(popupPrice[0].dataset.single).toFixed(2));
            }

            var qtyLeft = parseInt(maxQty) - qtyAdded

            qtyNode.attr('data-max', qtyLeft);
            if (parseInt(qtyNode[0].dataset.max) === 1) {
                $('.qtyCtl button').attr("disabled", true);
            }

            if ($('#qtyLeft').length && qtyLeft > 0) {
                $('#qtyLeft').text(qtyLeft);
            }

            if (qtyLeft > 0) {
                qtyNode.text('1');
            }
        }

        if ($('main').hasClass('pdt') && !$('.qtyCtl').length && !$('#quickBuyPopup').is(':visible')) {
            $('.addBasket').attr("disabled", true);
            $(this).children('span').css('visibility', 'hidden');
            $(this).append('<svg><use xlink:href="#loading" /></svg>');
            $(this).addClass('bLoad');

            var popupPrice = $('#popupAddBasketPrice');
            if ($(this).parent().parent().parent().parent().hasClass('retailers')) {
                var popupPrice = $(this);
            }
        }

        $.ajax({
            url: `${url_prefix}/basket/api/add/${pvid}/${qtyAdded}/`, type: 'GET', success: function (result) {
                $('.addBasket>span').show();
                $('.addBasket>span').css('visibility', 'visible');
                $('.addBasket').attr("disabled", false);
                $('.addBasket').removeClass('bLoad');
                $('.addBasket>svg').remove();

                $('.myBasketLnk span').remove();
                $('.myBasketLnk').append(' <span>(£' + result['total_order_gross'] + ')</span>');

                if ($('#quickBuyPopup').is(':visible')) {
                    $('#quickBuyPopup .inject .quickBuy').remove();
                    $('#quickBuyPopup').addClass('added');
                    $('#quickBuyPopup .hd span').text('Added to your bag');

                    $('#quickBuyPopup .inject').append(`<div class="f nw ac"><div class="img"><img width="75" height="75" src="${b_image}" alt="${b_product_name}"></div><div class="info"><div class="brand">${b_brand_name}</div><div class="name">${b_product_name}</div>${b_pv_name}</div><div> <b>${b_cur}${b_price}</b></div></div>`);
                    $('#quickBuyPopup .inject').append(`<div class="f w c ac dblBtn"><button class="btn myBasketLnk">View Bag <span>(£${result['total_order_gross']})</span></button><button class="btn fCls">Continue Shopping</button></div>`);
                } else {
                    openPopup('.added');
                    showOvly();
                    if ($('.qtyCtl').length) {
                        if (parseInt(qtyNode[0].dataset.max) == 0) {
                            $('.pdtCon .qty.low').hide();
                            $('.pdtBuy, .stickyBtn').html(`<button class="btn max" disabled="disabled">Max per order reached</button>`)
                        }
                    } else {
                        $('.pdtCon .qty.low').hide();
                        $('.pdtBuy, .stickyBtn').html(`<button class="btn max" disabled="disabled">Max per order reached</button>`)
                    }
                }

                getBasket(result);
                gaEcommerceEvent(pvid, 'add_to_cart', qtyAdded, result);
            }
        });

        if (getCookie("cshb") == "") {
            var d = new Date();
            d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = "cshb=1;" + expires + ";path=/";
        }

        applyVf();
    });

    $('body').on('click', '.qbuy', function (e) {
        e.preventDefault();
        var pvid = $(this)[0].dataset.pvid;
        var type = $(this)[0].dataset.type;
        var url = url_prefix + "/get-product/" + pvid + "/" + type + "/";

        $('.qbuy').attr("disabled", true);
        $(this).append('<svg><use xlink:href="#loading" /></svg>');
        $(this).addClass('bLoad');
        $('#quickBuyPopup').removeClass('added');
        $('#quickBuyPopup .inject').removeClass('updating');
        $('#quickBuyPopup .inject .quickBuy').remove();

        if (type == 'pvci') {
            url = url_prefix + "/get-product/" + pvid + "/" + type + "/?vf=" + pvid + "";
        }

        $.ajax({
            url: url,
            dataType: 'json',
            success: function (result) {
                $('#quickBuyPopup .hd span').text(result['title']);
                $('#quickBuyPopup .inject').html(result['html']);

                if (result['add']) {
                    $('#quickBuyPopup').addClass('added');
                    $.ajax({
                        url: `${url_prefix}/basket/api/add/${pvid}/1/`, type: 'GET', success: function (result) {
                            $('.myBasketLnk span').remove();
                            $('.myBasketLnk').append(' <span>(£' + result['total_order_gross'] + ')</span>');

                            $('#quickBuyPopup>.loading').hide();
                            openPopup('#quickBuyPopup');
                            showOvly();

                            $('.qbuy').attr("disabled", false);
                            $('.qbuy').removeClass('bLoad');
                            $('.qbuy>svg').remove();

                            getBasket(result);
                            gaEcommerceEvent(pvid, 'add_to_cart', 1, result);

                            if (getCookie("cshb") == "") {
                                var d = new Date();
                                d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
                                var expires = "expires=" + d.toUTCString();
                                document.cookie = "cshb=1;" + expires + ";path=/";
                            }

                            applyVf();
                        }
                    });
                } else {
                    $('#quickBuyPopup .inject .quickBuy .priceCon').append($('#quickBuyPopup .inject .quickBuy .pdtBuy .qty'));
                    $('#quickBuyPopup .inject .quickBuy .priceCon .price>span').add($('#quickBuyPopup .inject .quickBuy .priceCon .price>span').next()).wrapAll('<div></div>');

                    $('#quickBuyPopup>.loading').hide();
                    openPopup('#quickBuyPopup');
                    showOvly();

                    $('.qbuy').attr("disabled", false);
                    $('.qbuy').removeClass('bLoad');
                    $('.qbuy>svg').remove();
                }

                logProductImpression(pvid, true, 'quick buy');
            }
        });
    });

    /*AddLikes*/
    $('body').on('click', '.like, .qLike', function () {
        var pvid = $(this)[0].dataset.pvid;

        if ($(this).hasClass('qLike')) {
            var like = $(this).parent().parent().find('.like');
        } else {
            var like = $(this);
        }

        if (!$(like).hasClass('liked')) {
            $(like).addClass('liked');
            $(like).find('use').attr('xlink:href', '#heartSolid');

            if (logged_in != true) {
                openPopup('.login');
                $('.login .hd span').text("Saved for later!");
                $('.login #withSocial ul').hide();
                $('.login #withSocial p').show();
                showOvly();
            }

            $.get({
                url: url_prefix + "/faves/add/" + pvid + "/", success: function (result) {
                    getFavs(result);
                    gaEcommerceEvent(pvid, 'add_to_wishlist', 1, null);
                }
            });

        } else {
            $(like).removeClass('liked');
            $(like).find("use").attr("xlink:href", "#heart");

            $.get({
                url: url_prefix + "/faves/remove/" + pvid + "/", success: function (result) {
                    getFavs(result);
                }
            });
        }

        var d = new Date();
        d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = "cshf=1;" + expires + ";path=/";
    });

    /*Login*/
    $('body').on('click', '.myAct', function () {
        if (logged_in == true) {
            window.location.href = url_prefix + '/my-account/';
        } else {
            openPopup('.login');
            $('.login .hd span').text("Sign in or register");
            $('.login #withSocial ul').show();
            $('.login #withSocial p').hide();
            showOvly();
        }
    });

    /*My Account*/
    var get_logged_in = getCookie("csli");
    var get_favs = getCookie("cshf");
    if (get_logged_in == "1") {
        getFavs();
    } else {
        if ($('main.lgedin').length) {
            var d = new Date();
            d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = "csli=1;" + expires + ";path=/";

            getFavs();
        }
        if (get_favs == "1") {
            getFavs();
        }
    }

    $('body').on('click', '#withSwitch', function () {
        $('#withSocial').show();
        $('#withEmail').hide();
    });

    $('body').on('click', '#withLogin', function () {
        $('#withSocial').hide();
        $('#withEmail').show();
    });

    $('body').on('click', '#btnFbLogin', function () {
        dataLayer.push({ 'event': 'login', 'loginMethod': 'Facebook' });
        window.location.href = url_prefix + '/login/facebook/';
    });

    $('body').on('click', '#btnGoLogin', function () {
        dataLayer.push({ 'event': 'login', 'loginMethod': 'Google' });
        window.location.href = url_prefix + '/login/google-oauth2/';
    });

    $('body').on('click', '#withEmailSignup button', function (e) {
        e.preventDefault();
        if (emailValidation($('#withEmailSignup input')[0].value)) {
            var $button = $(this);
            $button.attr("disabled", true);
            $button.append('<svg><use xlink:href="#loading" /></svg>');
            $button.addClass('bLoad');
            dataLayer.push({ 'event': 'login', 'loginMethod': 'Email' });
            $.get({
                url: url_prefix + "/send_magic_link/" + $('#withEmailSignup input')[0].value + "/",
                success: function () {
                    $('#withEmailSignup, #withSwitch').hide();
                    $('.login .hd span, .tryagain h1').text("Email Sent!");
                    $('.login #withEmail p').addClass('suc').text("Check your inbox for our secure link to sign in to your account. If you can't see it, check your spam/junk folder.");
                },
                error: function (xhr) {
                    $button.attr("disabled", false);
                    $button.find('svg').remove();
                    $button.removeClass('bLoad');
                    var errorMsg = xhr.responseText || 'Something went wrong. Please try again.';
                    $('.login #withEmail p').html('<span style="color:#dd0000">' + errorMsg + '</span>');
                }
            });
        } else {
            $('.login #withEmail p').html('<span style="color:#dd0000">Please enter a valid email address and we\'ll send you a unique sign in link:</span>');
        }
    });

    /*Get basket count for header if the basket cookie has been set*/
    if (getCookie("cshb") == "1") {
        getBasket();
        applyVf();
    }

    $('.blogPost button.addBasket').each(function () {
        let pv = $(this)[0].dataset.pvslug;
        let haspvs = $(this)[0].dataset.haspvs;
        if (haspvs === "True") {
            let link = $(this).parent().parent().find('div>a:first, h2>a, h3>a, h4>a').attr("href");
            $(this).parent().parent().find('div>a:first, h2>a, h3>a, h4>a').attr("href", link + "?pv=" + pv);
        }
    });

    /*Product Page Specific*/
    $('a.btn.buy').each(function () {
        let redirect = $(this).attr("href");
        $(this).attr("href", redirect + "&c_source=" + lastClick + adUrl);
    });

    /*PRODUCT SLIDER*/
    if ($('.pdtImg>div').hasClass('pdtSlide')) {
        var pdtActiveImg = $('.pdtSlide .img .active').attr('id').substring(1);
        var pdtTotalImgs = $('.pdtSlide .img>div').length;

        var classname = document.querySelector('.pdtSlide')
        classname.addEventListener("touchstart", startTouch, { passive: true });
        classname.addEventListener("touchmove", moveTouch, { passive: true });
    }

    // Swipe Up / Down / Left / Right
    var initialX = null;
    var initialY = null;

    function startTouch(e) {
        initialX = e.touches[0].clientX;
        initialY = e.touches[0].clientY;
    }

    function moveTouch(e) {
        if (initialX === null) {
            return;
        }

        if (initialY === null) {
            return;
        }

        var currentX = e.touches[0].clientX;
        var currentY = e.touches[0].clientY;

        var diffX = initialX - currentX;
        var diffY = initialY - currentY;

        if (Math.abs(diffX) > Math.abs(diffY)) {
            // sliding horizontally
            if (diffX > 0) {
                // swiped left
                $('.pdtSlide .img>div, #pdtImgThbs img, #wDots li').removeClass("active");
                let pdtNext = parseInt(pdtActiveImg) + 1;
                if (pdtNext > pdtTotalImgs) { pdtNext = 1; }
                pdtActiveImg = pdtNext;
                changeSlideTo(pdtNext);
            } else {
                // swiped right
                $('.pdtSlide .img>div, #pdtImgThbs img, #wDots li').removeClass("active");
                let pdtPrev = parseInt(pdtActiveImg) - 1;
                if (pdtPrev == 0) { pdtPrev = pdtTotalImgs; }
                pdtActiveImg = pdtPrev;
                changeSlideTo(pdtPrev);
            }
        }

        initialX = null;
        initialY = null;
    }

    $('#pdtNext').click(function () {
        $('.pdtSlide .img>div, #pdtImgThbs img, #wDots li').removeClass("active");
        let pdtNext = parseInt(pdtActiveImg) + 1;
        if (pdtNext > pdtTotalImgs) { pdtNext = 1; }
        pdtActiveImg = pdtNext;
        changeSlideTo(pdtNext);
    });

    $('#pdtPrev').click(function () {
        $('.pdtSlide .img>div, #pdtImgThbs img, #wDots li').removeClass("active");
        let pdtPrev = parseInt(pdtActiveImg) - 1;
        if (pdtPrev == 0) { pdtPrev = pdtTotalImgs; }
        pdtActiveImg = pdtPrev;
        changeSlideTo(pdtPrev);
    });

    $('#wDots li, #pdtImgThbs img').click(function () {
        let pdtClickedImg = $(this).attr('id').substring(1);
        $('.pdtSlide .img>div, #pdtImgThbs img, #wDots li').removeClass("active");
        pdtActiveImg = pdtClickedImg;
        changeSlideTo(pdtClickedImg);
    });

    function changeSlideTo(slide) {
        $('#p' + slide).addClass("active");
        $('#t' + slide).addClass("active");
        $('#d' + slide).addClass("active");
    }

    $('#contactPopup').click(function () {
        $('form.cHide').slideToggle('slow');
    });

    if ($('main').hasClass('myaccount')) {
        if (logged_in == "") {
            var d = new Date();
            d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = "csli=1;" + expires + ";path=/";

            getFavs();
        }
    }

    $('body').on('click', '#shareWishlist', function () {
        showOvly();
        openPopup('.myAcShareLst');
    });

    if ($('main').hasClass('expired')) {
        $('#signInEmbed').append($('.login').html());
        $('#signInEmbed').addClass('login');
        $('#signInEmbed .tickLst, #signInEmbed #withSocial p, #signInEmbed .hd').remove();
    }
});

$(window).on('load', function () {
    if ($('main').hasClass('pdt')) {
        logProductImpression(pv_id, pv_in_stock, 'page');
    }

    /*Welcome Popup*/
    var lastClick = getCookie("csclick");

    function showWelcomePopup() {
        if (!$('body').hasClass('stopScroll') && logged_in === false) {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', 'TXVs3p']);
        }
    }

    if (getCookie("csli") === "" && getCookie("cswe") === "" && getCookie("cshb") === "" && getCookie("cshf") === "" && url_prefix === "" && !window.location.href.includes("my-account") && !window.location.href.includes("login") && !window.location.href.includes("contact") && !window.location.href.includes("partners") && !window.location.href.includes("press") && !window.location.href.includes("influencers") && !window.location.href.includes("policy") && !window.location.href.includes("terms-of-use") && !window.location.href.includes("faq") && !window.location.href.includes("delivery-returns") && !window.location.href.includes("=awin") && !window.location.href.includes("=affiliate") && ['csg', 'csg-search', 'csg-shopping', 'csms', 'csms-search', 'csms-shopping', 'csw', 'csb', 'csyt', 'cspi', 'csi', 'csf', 'csip', 'csfp', 'csop', 'cstt'].indexOf(lastClick) > -1) {
        var d = new Date();
        d.setTime(d.getTime() + (90 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = "cswe=1;" + expires + ";path=/";
        setTimeout(showWelcomePopup, 1500);
    } else if (getCookie("cswe") === "") {
        var d = new Date();
        d.setTime(d.getTime() + (90 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = "cswe=1;" + expires + ";path=/";
    }
});

/* Some functions may need to be inclued in scope for vite to compile correctly */
window.loadVariant = loadVariant;
// window.openPopup = openPopup;
// window.closePopup = closePopup;
// window.showOvly = showOvly;
// window.productAddedRedirect = productAddedRedirect;
// window.applyFilters = applyFilters;
// window.alertSignup = alertSignup;
// window.alertForm = alertForm;
// window.submitAlert = submitAlert;
// window.getFavs = getFavs;
// window.getBasket = getBasket;
// window.custIdentify = custIdentify;
// window.gaEcommerceEvent = gaEcommerceEvent;
// window.basketCount = basketCount;
// window.processBasketData = processBasketData;
// window.klaviyoAddToCart = klaviyoAddToCart;
// window.changeSlideTo = changeSlideTo;
// window.showRecentSearches = showRecentSearches;
// window.generateSearchItemHTML = generateSearchItemHTML;
// window.refineFilters = refineFilters;
// window.applyVf = applyVf;
// window.logProductImpression = logProductImpression;

window.getCookie = getCookie;
